export default __webpack_public_path__ + "static/media/dna-banner-image.089dfe39.png";